import { Fragment, type ReactNode } from "react";

export interface LegendItem {
    label: ReactNode;
    value: ReactNode;
    /** CSS variable name without `--` prefix (e.g., "color-chart-2") */
    color: string;
}

export interface LegendTableProps {
    items: LegendItem[];
}

const DOT_SIZE = "0.75rem";

export function LegendTable({ items }: LegendTableProps) {
    return (
        <div className="grid grid-cols-[auto_max-content_1fr] gap-x-2 gap-y-1">
            {items.map((item, index) => {
                const backgroundColor = `var(--${item.color})`;
                return (
                    <Fragment key={index}>
                        {/* Vertically center dot within first line: (line-height - dot-height) / 2 */}
                        <div
                            className="rounded-full self-start"
                            style={{
                                width: DOT_SIZE,
                                height: DOT_SIZE,
                                backgroundColor,
                                marginTop: `calc((1lh - ${DOT_SIZE}) / 2)`,
                            }}
                        />
                        <div>{item.label}</div>
                        <div className="font-bold text-right text-nowrap">{item.value}</div>
                    </Fragment>
                );
            })}
        </div>
    );
}
